export const exportHeaders = [
    {
        label: "Shipto",
        key: "henry_schein_account_number"
    },
    {
        label: "Account Name",
        key: "practice_name"
    },
    {
        label: "City",
        key: "city"
    },
    {
        label: "Email",
        key: "email"
    },
    {
        label: "Segment",
        key: "segment_code"
    },
    {
        label: "Plan",
        key: "plan"
    },
    {
        label: "Eligibility Source",
        key: "eligibility_source"
    },
    {
        label: "Review Status",
        key: "review_status"
    },
    {
        label: "Trial Period",
        key: "trial_period"
    },
    {
        label: "Request Received Date",
        key: "request_date"
    },
    {
        label: "Account Verified by",
        key: "account_verified_by"
    },
    {
        label: "Account Status",
        key: "account_verification_status"
    },
    {
        label: "Rejected Reason",
        key: "rejected_reason"
    },
    {
        label: "Sales Rep Email Id",
        key: "sales_rep_email_id"
    },
    {
        label: "Enrollment Start Date",
        key: "enrollment_date"
    },
    {
        label: "Comments",
        key: "comments"
    },
    {
        label: "Billing Notified",
        key: "internal_notification"
    },
    {
        label: "Welcome Email to Customer",
        key: "welcome_email_customer"
    },
    {
        label: "Welcome Email to FSC",
        key: "welcome_email_fsc"
    },
    {
        label: "Billing Verification by",
        key: "billing_verification_by"
    },
    {
        label: "Billing Start Date",
        key: "billing_start_date"
    },
    {
        label: "Sales Plan",
        key: "sales_plan"
    },
    {
        label: "Sales Plan Applied By",
        key: "sales_plan_applied_by"
    },
    {
        label: "Sales Plan Applied Date",
        key: "sales_plan_applied_date"
    },
    {
        label: "FF/Surcharge",
        key: "ff_surcharge"
    },
    {
        label: "FF/Surcharge Applied By",
        key: "ff_surcharge_applied_by"
    },
    {
        label: "FF/Surcharge Applied Date",
        key: "ff_surcharge_applied_date"
    },
    // {
    //     label: "HSD Service Rates Email status for Enrollments",
    //     key: "hsd_enrollment_status"
    // },
    {
        label: "HSD Service Rates Email status for Enrollments",
        key: "hsd_sync_date"
    },
    {
        label: "Qualified Spend Email",
        key: "qualified_merch_sales"
    }
    
]